/** Client-side download helper. Zero-egress: builds a Blob in the browser and
 *  triggers a local save — no network. */
export function downloadBlob(filename: string, mime: string, data: BlobPart): void {
  const blob = new Blob([data], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the click has been handled.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Slug for filenames: 'Contoso Ltd' -> 'contoso-ltd'. */
export function slugify(s: string): string {
  return (
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') || 'tenant'
  );
}

/** Short date stamp for filenames: 2026-07-25. */
export function dateStamp(iso: string): string {
  return iso.slice(0, 10);
}
